import _ from 'underscore';
import { isAudienceShoppingCampaign } from '@bingads-webui-campaign-react/constants';
import { AdTypes } from '@bingads-webui-campaign-react/campaign-onboarding-v2';
import biddingStrategyTypes from '@bingads-webui-campaign-legacy/bidding-strategy/bidding-strategy-type';

import { FLOWS } from '../constants';

export const isSearchShoppingCampaign = flow => flow === FLOWS.SHOPPING_SEARCH;

export const isAutoBidding = (bidStrategyType) => {
  const autoBidding = [biddingStrategyTypes.maximizeConversions, biddingStrategyTypes.maximizeClicks, biddingStrategyTypes.maxConversionValue, biddingStrategyTypes.targetRoas, biddingStrategyTypes.costPerSale];
  const result = _.contains(autoBidding, bidStrategyType);

  return result;
};

export const getBudgetBidSections = () => {
  const options = {
    basicOptions: [
      'bid-and-budget',
      'bid-value',
    ],
    advancedOptions: [
      'bid-adjustment',
    ],
  };

  return options;
};

export const allSettledPromiseWrapper = (promises) => {
  const wrappedPromises = promises.map(p => Promise.resolve(p)
    .then(
      val => ({ status: 'fulfilled', value: val }),
      err => ({ status: 'rejected', reason: err })
    ));
  return Promise.all(wrappedPromises);
};

export const getCampaignType = (isSearch, campaignSettings) => (isSearch ? {
  CampaignType: 'Shopping',
  CampaignSubType: undefined,
} : {
  CampaignType: 'Audience',
  CampaignSubType: campaignSettings ? campaignSettings.CampaignSubType : 'AudienceFeedBased',
});

export const getProductTileDetails = (product) => {
  if (!product) {
    return '';
  }
  let result = '';
  const operateMap = {
    equal: '=',
    notequal: '≠',
  };
  const conditionValueCount = Object.keys(product).filter(key => key.startsWith('ProductCondition') || key.startsWith('ProductValue')).length;
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i <= conditionValueCount / 2; i++) {
    const condition = product[`ProductCondition${i}`];
    const value = product[`ProductValue${i}`];
    const operatorString = product[`ProductOperator${i}`];
    const operator = operatorString ? (operateMap[operatorString] || operatorString) : '=';

    if (condition && value) {
      result += `${condition}${operator}${value} & `;
    }
  }

  return result.slice(0, -2); // remove the last &
};

export const getAdTypeFromCurrentCampaign = (currentCampaign) => {
  if (currentCampaign && isAudienceShoppingCampaign(currentCampaign.CampaignType, currentCampaign.CampaignSubType)) {
    return AdTypes.ShoppingAudience;
  }

  return AdTypes.AudienceAndSearch;
};

export const getNoValidStore = (productData, feedData) => (
  (_.isEmpty(productData) || _.isEmpty(productData.ProductCollectionAccounts) ||
  _.findIndex(productData.ProductCollectionAccounts, item => !item.IsGlobalStore && !item.IsCoOpStore) < 0) &&
  (_.isEmpty(feedData) || feedData.length <= 0)
);

